import type { HomeVgs } from '~/models/Content/HomeVgs'
import type { HomeAdult } from '~/models/Content/HomeAdult'
import type { Home8to10 } from '~/models/Content/Home8to10'
import type { Home5to7 } from '~/models/Content/Home5to7'
import type { Home1to4 } from '~/models/Content/Home1to4'
import type { ContentType } from '~/models/Content/ContentType'
import { useQuery } from '@tanstack/vue-query'
import { Subtree } from '~/models/Content/Subtree'
import useContentApi from '~/api/contentApi'

type HomeTypes = Home1to4 | Home5to7 | Home8to10 | HomeVgs | HomeAdult

type HomeContentTypes = ContentType.Home1to4
  | ContentType.Home5to7
  | ContentType.Home8to10
  | ContentType.HomeVgs
  | ContentType.HomeAdult

export default <T extends HomeTypes>(contentType: HomeContentTypes) => {
  const { findContents } = useContentApi()
  return useQuery({
    queryKey: ['home', 'dont-invalidate-on-grade-change', contentType],
    queryFn: () => findContents<T>({
      subtreeCriterion: [Subtree.App],
      contentTypeCriterion: [contentType],
    }, 1).then(([data]) => data),
    staleTime: Infinity,
  })
}
